<template>
  <div class="play-button">
    <a
      :href="href"
      class="btn --large"
      data-gamepad="level1"
      data-order="3"
      data-down="4"
      data-up="0"
    >
      <span class="btn__stroke"></span>
      <span class="btn__label">{{ $t("install") }} <iconInstall /></span>
    </a>
  </div>
</template>

<script>
import iconInstall from "@/components/Icons/iconInstall";

export default {
  components: {
    iconInstall
  },
  props: {
    href: {
      type: String,
      default: "",
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;
}

.btn.--large {
  margin: 0;
}

svg {
  width: 20px;
  position: relative;
  top: -2px;
  margin-left: 10px;
}
</style>
